import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import authenticationReducer from "./reducers/authenticationReducer";

const reducer = combineReducers({
  auth: authenticationReducer,
});

/**
 * Create own store
 * @returns store
 */
const createOwnStore = () => {
  const store = createStore(reducer, applyMiddleware(thunk));
  return store;
};

export default createOwnStore;
